import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { motion } from "framer-motion";
import { scrollToId } from "@/App";

const NAV = [
  { label: "Manifesto", id: "manifesto" },
  { label: "Directory", id: "directory" },
  { label: "Register", id: "register" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -72, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 inset-x-0 z-50 border-b border-stone_warm bg-ivory/80 backdrop-blur-xl"
      data-testid="site-header"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-12">
        <button
          onClick={() => scrollToId("hero")}
          className="flex items-center gap-2.5"
          data-testid="header-logo"
        >
          <span className="inline-block h-2 w-2 rotate-45 bg-gold" aria-hidden="true" />
          <span className="font-serif text-xl font-semibold tracking-tight text-charcoal">
            Joseph Guild
          </span>
        </button>

        <nav className="hidden items-center gap-10 md:flex" data-testid="header-nav">
          {NAV.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollToId(item.id)}
              className="group relative font-mono text-[11px] uppercase tracking-[0.22em] text-charcoal/70 transition-colors hover:text-charcoal"
              data-testid={`nav-${item.id}-link`}
            >
              {item.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-gold transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
          <button
            onClick={() => scrollToId("register")}
            className="rounded-full border border-charcoal bg-charcoal px-6 py-2.5 font-mono text-[11px] uppercase tracking-[0.22em] text-ivory transition-colors duration-300 hover:border-gold hover:bg-gold"
            data-testid="header-register-cta"
          >
            Join the Guild
          </button>
        </nav>

        <button
          className="md:hidden text-charcoal"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-stone_warm bg-ivory px-6 py-6 md:hidden" data-testid="mobile-menu">
          <div className="flex flex-col gap-5">
            {NAV.map((item) => (
              <button
                key={item.id}
                onClick={() => { setOpen(false); scrollToId(item.id); }}
                className="text-left font-mono text-xs uppercase tracking-[0.22em] text-charcoal/80"
                data-testid={`mobile-nav-${item.id}-link`}
              >
                {item.label}
              </button>
            ))}
            <Link to="/admin/login" className="font-mono text-xs uppercase tracking-[0.22em] text-charcoal/40" data-testid="mobile-admin-link">
              Admin
            </Link>
          </div>
        </div>
      )}
    </motion.header>
  );
};
